var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "../jsQuestionnaire/jsQuestionnaire.css";
import ObligationsQuestionnaireHeader from "../../molecules/obligationsQuestionnaireHeader/obligationsQuestionnaireHeader";
import Button from "../../atoms/button/button";
function Transition(props) {
    var handleContinue = props.handleContinue, handleSkip = props.handleSkip;
    return (_jsxs("div", __assign({ className: "questionnaire px-4 py-4 md:px-8 md:py-10 lg:px-16 lg:py-12 max-w-4xl mx-auto" }, { children: [_jsx(ObligationsQuestionnaireHeader, { title: props.title, content: props.content, classname: props.classname || "", width: props.width || "" }), _jsx("div", __assign({ className: "questionnaire-content mt-4 md:mt-6 lg:mt-8 rounded-lg p-4" }, { children: _jsxs("div", { children: [_jsx("hr", { className: "p-4" }), _jsxs("div", __assign({ className: "flex" }, { children: [_jsx(Button
                                // eslint-disable-next-line react/no-children-prop
                                , { 
                                    // eslint-disable-next-line react/no-children-prop
                                    children: "Skip", className: "back-btn flex-auto", primary: false, onClick: handleSkip }), _jsx(Button
                                // eslint-disable-next-line react/no-children-prop
                                , { 
                                    // eslint-disable-next-line react/no-children-prop
                                    children: "Proceed to Expectations", className: "continue-btn flex-auto", onClick: handleContinue })] }))] }) }))] })));
}
export default Transition;
